export default __webpack_public_path__ + "static/media/Arch_Amazon-Simple-Notification-Service_64.a95b7150.svg";